// NOTE: Match backend Enum
// (src/Domain/JANA.LH.Domain.Common/Enums/AssessmentStatusCode.cs)
export enum WISAssessmentStatusCode {
  New = 'New',
  DataPreparation = 'DataPreparation',
  InProcess = 'InProcess',
  RunningModels = 'RunningModels',
  PostProcessing = 'PostProcessing',
  PopulatingToDB = 'PopulatingToDB',
  PopulatingToMap = 'PopulatingToMap',
  Completed = 'Completed',
  Error = 'Error'
}
